<template>
    <div class="clearfix text-center">
        <br><br>
        <h5 v-if="getProp(notFoundSchedule, 'vehicle_category_id', 0)">Quý khách hãy thử chọn loại xe khác</h5>
        <h5 v-else-if="!getProp(notFoundSchedule, 'vehicle_category_id', 0) && tooLongBookDate">Quý khách vui lòng liên hệ với tổng đài 19000392 để mở chuyến vì ngày đặt quá xa.</h5>
        <h5 v-else>Quý khách vui lòng liên hệ với tổng đài 19000392.</h5>
        <br><br>
        <div class="text-center" v-if="getProp(notFoundSchedule, 'vehicle_category_id', 0)">
            <a style="color: #2f54eb; text-decoration: underline" href="javascript:void(0)" @click="tryOtherVehicle">Thử loại xe khác</a>
        </div>
        <div class="text-center">
            <img alt="" src="../../../assets/images/route-no-schedule.png" class="img img-responsive" style="margin-left: auto;margin-right: auto;">
        </div>
    </div>
</template>

<script>
    import {MixinHelper} from "../services";
    import endOfDay from 'date-fns/endOfDay';
    import {HCROUTES} from "../constants/Constant";

    export default {
        name: "NotFoundSchedulePage",
        mixins: [MixinHelper],
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                tooLongBookDate: false
            }
        },
        created() {
            const today = endOfDay(new Date()).valueOf();
            this.tooLongBookDate = this.notFoundSchedule.from_time > today;
        },
        methods: {
            tryOtherVehicle() {
                const query = this.filterParams({...this.notFoundSchedule, vehicle_category_id: 0});
                this.$router.push({name: HCROUTES.schedule, query: query});
            }
        },
        computed: {
            notFoundSchedule() {
                return this.data;
            }
        }
    }
</script>

<style scoped>
    .img-responsive {
        display: block;
        max-width: 100%;
        height: auto;
    }
</style>
